import CustomAsyncSelect from "./custom-async-select.component";

export default CustomAsyncSelect;
